import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { CalcType } from '../../../lookups/CalcType';
import * as PayrollItemActions from './payroll-item.actions';
import { PayrollItem } from './payroll-item.model';

export const payrollItemsFeatureKey = 'payrollItems';

export interface State extends EntityState<PayrollItem> {
    // additional entities state properties
    LaborTypes: CalcType[];
}

export const adapter: EntityAdapter<PayrollItem> =
    createEntityAdapter<PayrollItem>({
        selectId: (model: PayrollItem) => model.PIListID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    LaborTypes: []
});

const payrollItemReducer = createReducer(
    initialState,
    on(PayrollItemActions.addPayrollItem, (state, action) =>
        adapter.addOne(action.payrollItem, state)
    ),
    on(PayrollItemActions.upsertPayrollItem, (state, action) =>
        adapter.upsertOne(action.payrollItem, state)
    ),
    on(PayrollItemActions.addPayrollItems, (state, action) =>
        adapter.addMany(action.payrollItems, state)
    ),
    on(PayrollItemActions.upsertPayrollItems, (state, action) =>
        adapter.upsertMany(action.payrollItems, state)
    ),
    on(PayrollItemActions.updatePayrollItem, (state, action) =>
        adapter.updateOne(action.payrollItem, state)
    ),
    on(PayrollItemActions.updatePayrollItems, (state, action) =>
        adapter.updateMany(action.payrollItems, state)
    ),
    on(PayrollItemActions.deletePayrollItem, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(PayrollItemActions.deletePayrollItems, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(PayrollItemActions.loadPayrollItems, (state, action) =>
        adapter.setAll(action.payrollItems, state)
    ),
    on(PayrollItemActions.clearPayrollItems, state => adapter.removeAll(state)),
    on(PayrollItemActions.loadLaborTypes, (state, action) => ({
        ...state,
        LaborTypes: action.items
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return payrollItemReducer(state, action);
}
